import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-breadcrumb-toolbar',
  templateUrl: './breadcrumb-toolbar.component.html',
  styleUrls: ['./breadcrumb-toolbar.component.scss']
})
export class BreadcrumbToolbarComponent implements OnInit {

  @Input()
  breadcrumb1?: string;
  @Input()
  breadcrumb2?: string;
  @Input()
  title1?: string;
  @Input()
  title2?: string;
  @Input()
  code?: string;

  constructor() { }

  ngOnInit(): void {
  }

}
